import axios from "axios";
import { TWIN_SERVER_URL } from "../modules/config";

export default axios.create({
    baseURL: TWIN_SERVER_URL,
    headers: {
        "Content-type": "application/json"
    }
});
